import axios, { AxiosError } from 'axios'
import { useState, useEffect, useCallback } from 'react'
import { API_BRAND_SEARCH } from '../consts'
import { Brand } from './useBrand'

export const useBrands = (searchQuery: string | undefined) => {
  const [state, setState] = useState<{
    brands: Brand[]
    error: AxiosError | null
    isLoading: boolean
  }>({
    brands: [],
    error: null,
    isLoading: false,
  })
  const fetchBrands = useCallback(async () => {
    let query = searchQuery || ''

    try {
      setState((state) => ({ ...state, isLoading: true }))
      const response = await axios.get(`${API_BRAND_SEARCH}?query=${query}`)

      setState({ brands: response.data.product_brands, error: null, isLoading: false })
    } catch (err) {
      const data: any = { error: null, brands: [], isLoading: false }
      if (axios.isAxiosError(err)) {
        data.error = err
        data.brands = []
      }
      setState(data)
    }
  }, [searchQuery])

  useEffect(() => {
    fetchBrands()
    return () => setState({ brands: [], error: null, isLoading: false })
  }, [fetchBrands])

  return { ...state, refresh: () => fetchBrands() }
}
